var _g, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 256c-70.699 0-128-57.301-128-128s57.301-128 128-128c70.699 0 128 57.301 128 128s-57.301 128-128 128z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170.667 810.667v-341.333c0-48.213 16.683-92.245 43.776-128h-129.109c-47.147 0-85.333 38.187-85.333 85.333v256h85.333v213.333c0 23.552 19.115 42.667 42.667 42.667h85.333c23.552 0 42.667-19.115 42.667-42.667v-85.333h-85.333z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M597.333 1024h-170.667c-23.552 0-42.667-19.115-42.667-42.667v-256h-128v-256c0-70.699 57.301-128 128-128h256c70.699 0 128 57.301 128 128v256h-128v256c0 23.552-19.115 42.667-42.667 42.667z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170.667 298.667c-47.147 0-85.333-38.187-85.333-85.333s38.187-85.333 85.333-85.333c47.147 0 85.333 38.187 85.333 85.333s-38.187 85.333-85.333 85.333z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M853.333 810.667v-341.333c0-48.213-16.683-92.245-43.776-128h129.109c47.147 0 85.333 38.187 85.333 85.333v256h-85.333v213.333c0 23.552-19.115 42.667-42.667 42.667h-85.333c-23.552 0-42.667-19.115-42.667-42.667v-85.333h85.333z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M853.333 298.667c47.147 0 85.333-38.187 85.333-85.333s-38.187-85.333-85.333-85.333c-47.147 0-85.333 38.187-85.333 85.333s38.187 85.333 85.333 85.333z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeams);
export default __webpack_public_path__ + "static/media/teams.5bebd77bf6022e16bfad60bd191ea21f.svg";
export { ForwardRef as ReactComponent };